export const BASE_URL = "https://ai-coding-dev.aiotgroups.com/";
